import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

let csrfToken = null;

export async function ensureCsrfToken() {
  const { data } = await api.get("/auth/csrf");
  csrfToken = data.csrf_token;
  return csrfToken;
}

api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();

  if (
    csrfToken &&
    ["post", "put", "patch", "delete"].includes(method)
  ) {
    config.headers = config.headers || {};
    config.headers["X-CSRF-Token"] = csrfToken;
  }

  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
